module.exports = __webpack_public_path__ + "static/GilroyAlt-Medium-96ce27c03361c75d93803d38e2e2f2de.woff2";